import {
  workPackageNumberSequenceQuery,
  workPackageSettingsQuery,
} from "@common/api/work-packages"
import { useSuspenseQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { PageContent } from "@/components/page/page-content"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { NumberingForm } from "./general/-components/form/numbering-form"
import { SettingsForm } from "./general/-components/form/settings-form"

export const Route = createFileRoute(
  "/_layout/settings/_panel/work-orders/general",
)({
  staticData: {
    breadcrumb: [{ label: "Work orders - General" }],
  },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(
      queryClient,
      "work_package_settings:read",
      "/settings/workspace/general",
    ),
  loader: ({ context: { queryClient } }) =>
    Promise.all([
      queryClient.ensureQueryData(workPackageNumberSequenceQuery()),
      queryClient.ensureQueryData(workPackageSettingsQuery()),
    ]),
  component: WorkOrdersGeneralPage,
})

function WorkOrdersGeneralPage(): React.ReactElement {
  const { data: sequence } = useSuspenseQuery(workPackageNumberSequenceQuery())
  const { data: settings } = useSuspenseQuery(workPackageSettingsQuery())
  const showToast = useCustomToast()

  return (
    <PageContent>
      <NumberingForm
        sequence={sequence}
        onSave={() =>
          showToast("Saved", "Work order numbering updated.", "success")
        }
      />
      <SettingsForm
        settings={settings}
        onSave={() =>
          showToast("Saved", "Work order settings updated.", "success")
        }
      />
    </PageContent>
  )
}
